import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../util/Constants';
import LoginAPI from '../api/LoginAPI';
import Util from '../util/Util';
import withRouter from '../util/WithRouter';
import ApiUiController from '../controller/ApiUiController'; 

class AuthPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { inApiCall: false };
  }

  componentDidMount() {
    let tmp = reactLocalStorage.get(Const.LoggedIn);
    tmp = tmp && (typeof tmp) === 'number' ? `${tmp}` : tmp;
    if (tmp === Const.STrue) {
      this.props.navigate('/');
    } else {
      this.checkCredentials(this.props.match.params.auth);
    }
  }

  checkCredentials = auth => {
    this.setState({ ...this.state, inApiCall: true });
    LoginAPI.auth( auth, this.onResponse, this.failure, this.props.logout);
  };

  failure = res => { this.setState({ ...this.state, inApiCall: false }); Util.showError(res); }

  onResponse = response => {
    reactLocalStorage.set(Const.LoggedIn, Const.STrue);
    reactLocalStorage.set(Const.Token, response.auth);
    reactLocalStorage.set(Const.System, response.system);
    let code = response.user.default_code;
    response.user.default_code = code !== undefined ? code : "+91";
    reactLocalStorage.setObject(Const.LoggedInUser, response.user);
    this.props.navigate('/');
  }

  render() {
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div></div>
      </ApiUiController>        
    );
  }
}
export default withRouter(AuthPage);
